export default {
    components: {
        'modal-confirmation'    : () => import(/* webpackChunkName: "modal-confirmation" */ '@/app/shared/components/modals/ModalConfirmation'),
    },
    props: {
        title: {
            type: String,
            required: false,
            default: 'Information'
        },
        route: {
            type: String,
            required: true,
        },
        routeExport: {
            type: String,
            default: null
        },
        routeJob: {
            type: String,
            default: null
        },
        autoLoad: {
            type: Boolean,
            default: false
        },
        filters: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        allowExportData: {
            type: Boolean,
            default: false
        },
        titleExportData: {
            type: String,
            default: 'Exportar Informação'
        },
        textExportData: {
            type: String,
            default: 'Exportação em  execução...'
        },
        finalTextExportData: {
            type: String,
            default: 'Exportação concluída'
        },
        confirmExportData: {
            type: Boolean,
            default: true,
        },
        confirmMsgExportData: {
            type: String,
            default: 'Pretende exportar a informação?'
        },
        errorMsgExportData: {
            type: String,
            default: 'Não foi possível exportar a informação'
        },
        newWindowExportData: {
            type: Boolean,
            default: true
        },
    },
    data(){
        return {
            loadingMsg: 'Loading...',
            loaded: false,
            notFoundMsg: 'Sem resultados',
            orderByTemplate: 'Ordenar por {field}',
            settings: {},
            data: [],
        }
    },
    computed: {
        urlParams() {
            let params = {}
            const filters = this.filters;
            // Object.keys(filters).forEach( (key) => {
            //     const val = filters[key];
            //     if (val) {
            //         params[key] = val;
            //     }
            // });
            params['filter'] = filters;
            Object.assign(params, this.extraQueryParams);
            return params;
        },
        extraQueryParams() {
            let params = {};
            // params['title'] = this.title;
            return params;
        },
        queryParams() {
            return {
                params: this.urlParams,
            }
        },
        hasData() {
            return !!this.data.length;
        }
    },
    async mounted() {
        if(this.states){
            this.states.forEach((status) => {
                this.columns.push({id: status.id, label: status.name})
            });
        }
        await this.request();
    },
    methods: {
        async request() {
            if(this.autoLoad){
                if(this.isLoading()) return
                this.loading(true);

                let options = this.queryParams;
                await this.$http.get(this.route, options)
                .then(({data}) => {
                    this.data = data.data ? data.data : [];
                    this.loaded = true;
                })
                .finally(() => {
                    this.loading(false);
                })
                .catch((error) => {
                    this.showError(error)
                    this.loaded = false;
                })
            }
        },
        onExport() {
            // this.$root.$emit('openConfirmation', {
            //     id: null,
            //     data: null,
            //     text: this.confirmMsgExportData,
            //     callback: (itemId) => {
            //         let options = this.queryParams;
            //         options.params['export'] = 1;
            //         this.$http.get(this.route, options)
            //         .then(({data}) => {
            //             if(data.data){
            //                 if(this.newWindowExportData){
            //                     window.open(data.data, '_blank');
            //                 }
            //                 this.$emit('exported-data', data);
            //             }else{
            //                 this.showError({message: this.errorMsgExportData, title: this.title})
            //             }
            //         })
            //         .finally(() => {
            //         })
            //         .catch((error) => {
            //             this.showError(error);
            //             this.$emit('exported-error-load', error);
            //         })
            //     }
            // });
            this.$root.$emit('openExport', {
                confirmExport: this.confirmExportData,
                confirmMessage: this.confirmMsgExportData,
                title: this.titleExportData,
                text: this.textExportData,
                finalText: this.finalTextExportData,
                urlExport: this.routeExport,
                urlJob: this.routeJob,
                options: this.queryParams,
                callback: (data) => {

                },
            });
        },
        showError: function(error) {
            this.$root.$helper.error.httpError(error);
        },
        getValueFromJson(numbers, column, prop='qty') {
            let el = JSON.parse(numbers).find(n => n.id==column.id);
            return el ? (el.hasOwnProperty(prop) ? el[prop] : 0) : 0;
        },
        getValueFromItem(item, column, prop='total') {
            let el = item.find(n => n.id==column.id);
            return el ? (el.hasOwnProperty(prop) ? el[prop] : 0) : 0;
        }
    },
    watch:{
        'filters': {
            handler(){
                this.request();
            },
            deep: true,
        },
    },
}
